import { useEffect, useState } from "react";
import BlogService from "../../services/api/blog.service";
import { toast } from "../../utils/notify";

type SitemapItem = {
  loc: string;
  lastmod?: string;
};

export default function SitemapPage() {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  const formatXml = (xml: string) => {
    return xml.replace(/></g, ">\n<").trim();
  };

  const fetchData = async () => {
    setLoading(true);

    try {
      const sitemap = await BlogService.generateSitemap();

      if (!sitemap) {
        toast("Lấy sitemap thất bại", "error");
        return;
      }

      setData(sitemap);
    } catch (err) {
      console.error(err);
      toast("Có lỗi khi load sitemap", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <pre style={{ padding: 20 }}>{data ? formatXml(data) : "Loading..."}</pre>
  );
}
